import "./App.css";
import db from "./firebase";
import { useEffect, useRef } from "react";
import { BrowserRouter as Router, Switch, Route } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { collection, getDocs, query, where } from "firebase/firestore";
import MyAccount from "./components/MyAccount/MyAccount";
import AdminPanel from "./components/AdminPanel/AdminPanel";
import PageNotFound from "./components/PageNotFound/PageNotFound";
import {
  updateUserUid,
  updateUserName,
  updateUserUsername,
  updateUserEmail,
  updateUserProfileImage,
  updateCelebData,
  updateActiveCelebData,
  updateUserFavorites,
  hideSidePanelWindow,
  removeBannerDelay,
  updateUserCollections,
  updateUserWallet,
  toggleMenuBar,
} from "./store/actions";
import Homepage from "./components/Homepage";
import { getCookie, checkCookie } from "./components/Common";

function App() {
  const dispatch = useDispatch();
  const activeCelebId = useSelector((state) => state.activeCelebId);

  // set default false in menubar
  useEffect(() => {
    if (window.innerWidth < 576) {
      dispatch(toggleMenuBar());
    }
  }, [dispatch]);

  // search panel working
  let sidebarRef = useRef();
  useEffect(() => {
    let outsideClick = (event) => {
      if (sidebarRef.current !== null && sidebarRef.current !== undefined) {
        if (!sidebarRef.current.contains(event.target)) {
          dispatch(hideSidePanelWindow());
          setTimeout(() => dispatch(removeBannerDelay()), 80);
        }
      }
    };
    document.addEventListener("mousedown", outsideClick);
    return () => {
      document.removeEventListener("mousedown", outsideClick);
    };
  }, [dispatch]);

  // get data on load
  useEffect(() => {
    async function getAllData() {
      const collectionn = await getDocs(collection(db, "biddify"));
      const tempData = [];
      collectionn.forEach((doc) => {
        tempData.push({
          handle: doc.data().handle,
          name: doc.data().name,
          followers: doc.data().follwers,
          id: doc.data().id,
          public_id: doc.data().public_id,
          verified: doc.data().verified,
        });
      });
      dispatch(updateCelebData(tempData));
      const activeImages = await getDocs(
        collection(db, `biddify/${activeCelebId}/gallery`)
      );
      const temppData = [];
      activeImages.forEach((doc) => {
        temppData.push({
          id: doc.data().id,
          highestBid: doc.data().highestBid,
          timeLeft: doc.data().timeLeft,
          startTime: doc.data().startTime ? doc.data().startTime : 0,
          public_id: doc.data().public_id,
        });
      });
      dispatch(updateActiveCelebData(temppData));
    }
    const interval = setInterval(() => getAllData(), 1000);
    return () => clearInterval(interval);
  }, [dispatch, activeCelebId]);

  // set active user on load
  useEffect(() => {
    async function setUser() {
      const userData = await getDocs(
        query(
          collection(db, "user_data"),
          where("token", "==", getCookie("active_user"))
        )
      );
      userData.forEach((doc) => {
        dispatch(updateUserUid(doc.data().uid));
        dispatch(updateUserName(doc.data().name));
        dispatch(updateUserUsername(doc.data().username));
        dispatch(updateUserEmail(doc.data().email));
        dispatch(updateUserProfileImage(doc.data().profile_image));
        dispatch(updateUserWallet(doc.data().wallet));
        dispatch(
          updateUserFavorites(doc.data().favorites ? doc.data().favorites : [])
        );
      });
      const temp = [];
      const collectionData = await getDocs(
        query(
          collection(db, `user_data/${userData.docs[0].data().uid}/collections`)
        )
      );
      collectionData.forEach((doc) => {
        temp.push(doc.data());
      });
      dispatch(updateUserCollections(temp));
    }
    if (checkCookie("active_user")) {
      setUser();
    }
  }, [dispatch]);

  return (
    <Router>
      <Switch>
        <Route path="/" component={Homepage} exact />
        <Route path="/my-account" component={MyAccount} />
        <Route path="/admin" component={AdminPanel} />
        <Route path="*" component={PageNotFound} exact />
      </Switch>
    </Router>
  );
}

export default App;
